import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import axios from 'axios';
import { bundle } from '../../helpers';
import { fetchProfile } from '../../apis';
import { handleErrors } from '../http';
export var login = function login(_ref) {
  var username = _ref.username,
      password = _ref.password;
  return axios.post("".concat(bundle.spaceLocation(), "/app/login.do"), {
    j_username: username,
    j_password: password
  }, {
    __bypassAuthInterceptor: true
  })["catch"](handleErrors);
};
export var logoutDirect = function logoutDirect() {
  return axios.get("".concat(bundle.spaceLocation(), "/app/logout"));
};
var checkedOrigin = process.env.REACT_APP_API_HOST ? process.env.REACT_APP_API_HOST : typeof window !== 'undefined' ? window.location.origin : null;
var clientId = process.env.REACT_APP_OAUTH_CLIENT_ID || 'system';
export var retrieveJwt = function retrieveJwt() {
  return new Promise(function (resolve) {
    var iframe = document.createElement('iframe');
    iframe.src = bundle.spaceLocation() + '/app/oauth/authorize?grant_type=implicit&response_type=token&client_id=' + clientId;
    iframe.title = 'oauth jwt iframe';
    iframe.style.cssText = 'display: none';

    var listener = function listener(e) {
      if (e.origin === checkedOrigin && e.data.token) {
        window.removeEventListener('message', listener);
        document.body.removeChild(iframe);
        resolve(e.data.token);
      }

      if (e.origin === checkedOrigin && e.data.type === 'ping') {
        e.source.postMessage({
          type: 'pong'
        }, e.origin);
      }
    };

    window.addEventListener('message', listener);
    document.body.appendChild(iframe);
  });
};
export var singleSignOn = function singleSignOn(spaceSlug, dimensions) {
  var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '_blank';
  return new Promise(function (resolve) {
    var options = _objectSpread(_objectSpread({}, dimensions), getPopupPosition(window, dimensions));

    var endpoint = bundle.spaceLocation() + '/app/saml/login/alias/' + spaceSlug;
    var popup = window.open(endpoint, target, stringifyOptions(options)); // Create an event handler that closes the popup window if we focus the
    // parent window

    var windowFocusHandler = function windowFocusHandler() {
      popup.close();
      window.removeEventListener('focus', windowFocusHandler);
    };

    window.addEventListener('focus', windowFocusHandler); // use a larger interval in dev mode because we are going to be checking
    // by making an ajax call

    var popupPollingInterval = 2000;
    var pollCounter = 30; // Check the status of the popup window. If closed or open for too long,
    // show error. Otherwise, check if profile is avilable to verify successful
    // authentication.

    var checkPopup = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!popup.closed) {
                  _context.next = 4;
                  break;
                }

                resolve({
                  error: 'Single Sign-on cancelled'
                });
                _context.next = 12;
                break;

              case 4:
                _context.next = 6;
                return profileAvailable();

              case 6:
                if (!_context.sent) {
                  _context.next = 11;
                  break;
                }

                popup.close();
                resolve({});
                _context.next = 12;
                break;

              case 11:
                if (pollCounter > 0) {
                  pollCounter--;
                  setTimeout(checkPopup, popupPollingInterval);
                } else {
                  popup.close();
                  resolve({
                    error: 'Single Sign-on timed out'
                  });
                }

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function checkPopup() {
        return _ref2.apply(this, arguments);
      };
    }(); // Start the recursive checkPopup calls.


    setTimeout(checkPopup, popupPollingInterval);
  });
}; // Checks to see if the user has been authenticated via SSO by checking if the
// profile endpoint successfully returns data.

var profileAvailable = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise( /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
                var result;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.prev = 0;
                        _context2.next = 3;
                        return fetchProfile({
                          "public": true
                        });

                      case 3:
                        result = _context2.sent;
                        resolve(!!result.profile);
                        _context2.next = 10;
                        break;

                      case 7:
                        _context2.prev = 7;
                        _context2.t0 = _context2["catch"](0);
                        resolve(false);

                      case 10:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, null, [[0, 7]]);
              }));

              return function (_x) {
                return _ref4.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function profileAvailable() {
    return _ref3.apply(this, arguments);
  };
}(); // window.open takes a string of options rather than a JS object so we use this
// helper to do that conversion.


var stringifyOptions = function stringifyOptions(options) {
  return Object.keys(options).reduce(function (reduction, option) {
    return [].concat(_toConsumableArray(reduction), ["".concat(option, "=").concat(options[option])]);
  }, []).join(',');
}; // Given the dimensions of the popup and the parent window returns the correct
// position for the popup to be centered within the parent.


var getPopupPosition = function getPopupPosition(window, _ref5) {
  var width = _ref5.width,
      height = _ref5.height;
  return {
    top: window.screenY + window.innerHeight / 2 - height / 2,
    left: window.screenX + window.innerWidth / 2 - width / 2
  };
};